'use strict'

import template from './request.template.pug'

class RequestSupportController {
  constructor($mdToast, $mdDialog, SessionService) {
    'ngInject'
    Object.assign(this, { $mdToast, $mdDialog, SessionService })
  }

  $onInit() {
    this.phone = this.SessionService.currentUser.user.phone
  }

  send() {
    return this.customer
      .sendSupport({
        subject: this.subject,
        phone: this.phone,
        message: this.message,
      })
      .then(() => {
        this.$mdDialog.hide()
        const toast = this.$mdToast
          .simple()
          .textContent('Danke für Ihre Anfrage.')
          .action('OK')
          .position('bottom')
          .hideDelay(10000)
        this.$mdToast.show(toast)
      })
  }

  cancel() {
    this.$mdDialog.cancel()
  }
}

export const requestSupportComponent = {
  controller: RequestSupportController,
  controllerAs: '$ctrl',
  clickOutsideToClose: false,
  escapeToClose: true,
  template: template(),
  fullscreen: true,
  bindToController: true,
}

export const requestSupportConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('requestSupportDialog', {
    options: () => {
      return requestSupportComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/support/containers/request/request.component.js